import React from 'react'

import img from '../../assets/logo.png'
import { CiLocationOn } from 'react-icons/ci'
import { BiPhoneCall } from 'react-icons/bi'
import { HiOutlineMail } from 'react-icons/hi'
import { TbWorld } from "react-icons/tb";

const InfoSection = () => {
    return (
        <div>
            <div className="flex justify-between items-start  p-5">
                <div className="md:w-2/5 w-full">
                    <div className="space-y-4">
                        <img src={img} alt="" className="w-[200px]" />

                        <h2 className="md:text-4xl text-lg font-semibold">Track & Trace</h2>
                        {/* <p className="md:text-lg text-sm">One Union Solution</p> */}
                    </div>
                </div>
                <div className="md:w-2/5 w-full">
                    {/* <h2 className="md:text-4xl text-lg font-semibold">Contact</h2> */}

                    <div className="space-y-2 ">
                        <div className="flex gap-2 items-center">
                            <div className="border-2   p-2 rounded-full"><CiLocationOn className='text-[#3F93FF]' /></div>
                            <p className="text-black">Legmeerdijk 169C, 1432 KA Aalsmeer, Netherlands</p>
                        </div>

                        <div className="flex gap-2 items-center">
                            <div className="border-2   p-2 rounded-full"><BiPhoneCall className='text-[#3F93FF]' /></div>
                            <p className="text-black">+31 85-0600753</p>
                        </div>

                        <div className="flex gap-2 items-center">
                            <div className="border-2   p-2 rounded-full"><HiOutlineMail className='text-[#3F93FF]' /></div>
                            <p className="text-black">operations@oneunionsolutions.com</p>
                        </div>

                        <div className="flex gap-2 items-center">
                            <div className="border-2   p-2 rounded-full"><TbWorld className='text-[#3F93FF]' /></div>
                            <p className="text-black">www.oneunionsolutions.com</p>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default InfoSection